export default __webpack_public_path__ + "static/media/rozvrhscreenshot.45bd5c95.png";